/** @jsx jsx */
import React, { useRef } from 'react';

import styled from '@emotion/styled';
import { jsx } from '@emotion/react';

import { useFormFields } from '../../hooks';
import { useFormEvents, Event } from './useFormEvents';
import { Fields } from '../../components/Fields';
import { Loader } from '../../components/Loader';

interface ContainerProps {
    fields: any;
    event: Event;
}

export const Form: React.FC<ContainerProps> = ({ fields, event, ...props }) => {
    const [fieldValues, setFieldValues] = useFormFields(fields);
    const [fieldErrors, setFieldErrors] = useFormFields(fields);

    const { onSubmit, showLoader } = useFormEvents(event, fieldValues);

    if (showLoader) {
        return <Loader />;
    }

    return (
        <StyledForm {...props} onSubmit={onSubmit}>
            <Fields
                fields={fields}
                fieldValues={fieldValues}
                setFieldValues={setFieldValues}
                fieldErrors={fieldErrors}
                setFieldErrors={setFieldErrors}
                inputType="formField"
            />
        </StyledForm>
    );
};

const StyledForm = styled.form`
    width: 100%;

    margin: 0 auto;
`;
